<template>
    <v-dialog
        v-if          = "document"
        v-model       = "show"
        max-width     = "630"
        class         = "white"
        :scrollable   = "false"
        content-class = "dialog-border"
        persistent
        no-click-animation
    >
        <div class="primary--text white pt-2 pb-1 v-flex" >
            <v-select
                v-if           = "stamps.items"
                :disabled      = "loading"
                :items         = "stamps.items"
                v-model        = "stamps.selected"
                item-value     = "id"
                item-text      = "name"
                :return-object = true
                class          ="pt-2 pb-2 ml-4 mr-0"
                style          ="max-width: 315px"
                @change        = "onStamp"
                solo
                dense
                hide-details
            >
                <template v-slot:prepend-inner>
                    <v-icon size="20" color="primary">mdi-stamper</v-icon>
                </template>
            </v-select>

            <div class="ml-4" style="margin-top: 10px;">
                <c-toolbar-button
                    icon     = "mdi-minus-circle"
                    :color   = "stampSize > 0 ? 'primary' : 'dialog-button-inactive'"
                    size     = "26"
                    :tooltip = "$t('stamp.smaller')"
                    @click   = "onMinus"
                />
            </div>

            <div class="stamp-size primary white--text">
                {{ stampSizeText }}
            </div>

            <div class="ml-1" style="margin-top: 10px;">
                <c-toolbar-button
                    icon     = "mdi-plus-circle"
                    :color   = "stampSize < 3 ? 'primary' : 'dialog-button-inactive'"
                    size     = "26"
                    :tooltip = "$t('stamp.greater')"
                    @click   = "onPlus"
                />
            </div>


            <v-spacer />
            <div class="mt-2 mr-3">
                <c-toolbar-button
                    icon="mdi-close"
                    size="30"
                    color="red"
                    @click = "onCancel"
                />
            </div>
        </div>

        <div class="white" v-if = "loading">
            <v-progress-linear
                color  = "primary"
                height = "4"
                indeterminate
            />
        </div>

        <div class="white" style="height: 4px;" v-if = "!loading">
        </div>

        <v-card class="white" active-class="white" style="border-top-right-radius: 0; border-top-left-radius: 0; min-height: 847px;">
            <div class="text-center pt-0" >
                <div>
                    <inc-drag-stamp
                        v-show="!loading"
                         ref      = "stamp"
                        :image    = "stampImage"
                        :width    = "width"
                        @position = "onPosition"
                    />


                        <img
                            v-if   = "image"
                            ref    = "image"
                            :src   =  "image"
                            alt    = ""
                            height = "840px"
                        />
                </div>
            </div>

            <v-divider class="pt-2" />
            <v-card-actions class="pt-0 pb-2">
                <v-pagination
                    :disabled = "loading"
                    v-model="page"
                    :length="pages"
                    :total-visible = "4"
                    circle
                    @input = "onPage"
                ></v-pagination>

                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click = "onPerform"
                    color  = "white"
                    class = "dialog-button mr-0 primary"
                >
                    {{ $t('inc.stamper.stamp') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import Core         from "@/modules/core/service/Core";
import Dms          from "@/modules/dms/common/service/Dms";
import Inb          from "@/modules/inb/service/Inb";
import Msd          from "@/modules/msd/common/service/Msd";
import security     from "@/main";
import { getApiBaseUrl } from "@/config";
import IncDragStamp from "@/modules/dms/stamp/components/private/IncDragStamp.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "DDmsStamper",

    components: {
        CToolbarButton,
        IncDragStamp
    },

    props: {
        stamp: {
            required: false,
            default : () => {
                return "INVOICE";
            }
        }
    },

    data: () => ({
        loading     : true,
        show        : false,
        image       : null,
        stampImage  : null,
        document    : null,
        pages       : null,
        page        : 1,
        stampSize   : 2,
        position: {
            x: 200,
            y: 200
        },
        stamps: {
            items   : null,
            selected: null,
        }
    }),

    computed: {
        stampSizeText () {
            return this.$t("stamp.size." + this.stampSize);
        },

        width () {
            let width = 80;
            switch (this.stampSize) {
                case 0:
                    width = 120;
                    break;
                case 1:
                    width = 150;
                    break;
                case 2:
                    width = 180;
                    break;
                case 3:
                    width = 210;
                    break;
            }

            if (this.stamps.selected && (this.stamps.selected.id === "INVOICE_GWH_1" || this.stamps.selected.id === "INVOICE_GWH_2")) {
                width = width * 2.0;
            }

            return width;
        }
    },

    methods: {
        open (document) {
            this.loading = true;
            this.show = true;
            this.document = document;
            this.image = null;
            this.pages = null;
            this.page  = 1;

            Msd.globalstamp.loadAll().then (stamps => {
                this.stamps.items = stamps;
                this.stamps.selected = this.stamps.items.find(s => s.id === this.stamp);
                this.loadStamp();

                Dms.pages(this.document.id).then (data => {
                    this.pages = data.pages;
                    this.loadImage();
                });
            })
        },

        onPosition (position) {
            this.position = position;
        },

        onPage () {
            this.loadImage ();
        },

        onCancel () {
            this.show = false;
            this.$emit("closed");
        },

        onPerform () {
            this.show = false;
            fetch(this.stampImage).then(r => r.blob()).then(blob => {
                this.stampRequest(blob);
            });
        },

        onStamp () {
            this.loadStamp();
        },

        onMinus () {
            if (this.stampSize > 0) {
                this.stampSize --;
            }
        },

        onPlus () {
            if (this.stampSize < 3) {
                this.stampSize ++;
            }
        },

        loadImage () {
            this.loading = true;
            Dms.image(this.document.id, this.page-1, (image) => {
                 this.image = image;
                this.loading = false;
            }, (error) => {
                this.loading = false;
                Core.message.error(this, error, true);
            })
        },

        loadStamp () {
            Msd.stamp.prepare(this.stamps.selected.id, data => {
                this.stampImage = data;
                this.loading = false;
            });
        },

        stampRequest (blob) {
            const sizeStamp = this.$refs.stamp.size ();
            const sizeImage = this.size();

            const y = sizeImage.height - this.position.y - sizeStamp.height;
            const x = this.position.x - 20;
            const page = this.page-1;

            let formData = new FormData();

            formData.append("image", blob);
            formData.append("page",  page.toString());
            formData.append("width", this.width.toString());
            formData.append("x",     x.toString());
            formData.append("y",     Math.trunc(y).toString());

            fetch(getApiBaseUrl() + Dms.url.stamp.replace("{0}", this.document.id), {
                method :'POST',
                headers: security.header(),
                body   : formData
            })
                .then(data => security.response (data))
                .then(response => {
                    this.confirm = false;
                    this.stamped = true;
                    this.document = null;
                    Dms.open(response.id, this.$t("stamp.result"));
                    this.$bus.$emit(Inb.event.refresh);
                    this.$emit("stamped")
                })
                .catch(() => {
                    this.confirm = false;
                })
            this.document = null;
        },

        size () {
            return {
                height: this.$refs.image.clientHeight,
                width : this.$refs.image.clientWidth,
            };
        },
    }
}
</script>

<style scoped>

.stamp-header {
    font-weight: 700;
    font-size: 16px;
    padding-left: 18px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.stamp-size {
    margin-left: 4px;
    margin-top: 10px;
    margin-bottom: 9px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 3px;
    width: 90px;
    text-align: center;
    border-radius: 16px;
    font-size: 14px;
}

.dialog-button {
    min-width: 125px;
}

::v-deep .dialog-button-inactive--text {
    color: lightgray;
    background-color: white;
}

::v-deep .v-text-field.v-text-field--solo.v-input--dense>.v-input__control {
    min-height: 30px;
}


</style>